

export enum PageType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  VIEW = 'VIEW',
  DELETE = 'DELETE'
}

export enum OrderPageType {
  CREATE_UPDATE = 'CREATE_UPDATE',
  VIEW = 'VIEW',
  VIEW_ALL = 'VIEW_ALL'
}

export enum PageMode {
  PAGE = 'PAGE',
  MODAL = 'MODAL'
}


export enum CustomerTabs {
  INVOICES = 'INVOICES',
  PAYMENTS = 'PAYMENTS',
  OVERVIEW = 'OVERVIEW',
  SALES = 'SALES',
  STATEMENT = "STATEMENT",
  VEHICLES = "VEHICLES",
  TRANSPORTS = 'TRANSPORTS',
  ORDERS = 'ORDERS',
  REPORTS = 'REPORTS',
  ESTIMATE = 'ESTIMATE',
  EXPENSES = 'EXPENSES',
  WORKSHEETS = 'WORKSHEETS',
  CLOSURE_HISTORY = 'CLOSURE_HISTORY',
  CALL_LOGS = 'CALL_LOGS',
  ACTIVITIES = 'ACTIVITIES',
  REMINDERS = 'REMINDERS'
}

export enum InvoiceTabs {
  INVOICE = 'INVOICE',
  TRANSPORT = 'TRANSPORT',
  DELIVERY = 'DELIVERY'
}

export enum GSTypes {
  GOODS   = 1,
  SERVICE = 2
}

export enum GSCategory {
  PURCHASE  = 'purchase',
  SALES     = 'sales'
}

